/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/cog_medium'
export default icon
